import React, { useEffect, useState } from "react";

import "./AuditItemInfo.css";
import { useTranslation } from 'react-i18next';
import { IAudit } from "src/app/audit/~store/models/Audit";
import { ConvertFromAuditStatus } from "src/app/audit/helpers/audit-helper"
import { ModalWindow } from "src/app/shared/components/modal-window/ModalWindow";
import { Button } from "reactstrap";
import { getDateTime } from "src/app/shared/helpers/date-helper/DateFormats";

interface IAuditItemInfoProps {
    audit: IAudit,
    operatorName: string,
    onClose: () => void;
}

export const AuditItemInfo = (props: IAuditItemInfoProps) => {
    const { t } = useTranslation();

    const _header = (): JSX.Element => {
        return(
            <div className="audit-item-info-header"><b>{t('common.audit')}</b></div>
        )
    }

    const _body = (): JSX.Element => {
        return(
            <div className="audit-item-info-container">
                <div><span className="audit-item-info-label">{t('common.operator')}</span> <span>{props.operatorName}</span></div>
                <div><span className="audit-item-info-label">{t("common.type")}</span> <span>{ConvertFromAuditStatus(props.audit.type)}</span></div>
                <div><span className="audit-item-info-label">{t('common.date')}</span> <span>{getDateTime(props.audit.timestamp)}</span></div>
                <div><span className="audit-item-info-audit-data">{props.audit.data}</span></div>
            </div>
        )
    }

    const _footer = (): JSX.Element => {
        return(
            <div>
                <Button className="audit-info-close" onClick={props.onClose}>{t('common.close')}</Button>
            </div>
        )
    }

    return (
        <ModalWindow header={_header()} body={_body()} footer={_footer()} isOpen={true}/>
    );
}